import React, { useEffect, useRef, useState } from 'react';
import useStyles from './style';
import { Tooltip } from '@svg/antd';

interface EllipsisTooltipProps {
    text: any; // 文本数据
    containerLength: number; // 外容器长度
    style?: React.CSSProperties;
}

/**
 * @description 截断文本显示省略号，显示气泡
 * 调用的上级容器需要加max-width样式
 */
export default function EllipsisTooltip(props: EllipsisTooltipProps) {
    const { styles } = useStyles();

    const textRef = useRef(null);
    const [title, setTitle] = useState<string>("");

    useEffect(() => {
        let title = "";
        if (!textRef.current || props.containerLength == undefined || props.text == undefined) {
            setTitle("");
            return;
        }
        const textWidth = (textRef.current as any).offsetWidth;
        // 文本长度大于容器长度时显示气泡
        if (textWidth > props.containerLength) {
            title = props.text;
        }
        setTitle(title);
    }, [textRef.current, props.containerLength, props.text]);

    return (
        <Tooltip title={title}>
            <div ref={textRef} className={styles.ellipsisTooltipTextBox} style={props.style}>
                {props.text}
            </div>
        </Tooltip>
    )
}